import { Button, Image, Text, Link } from "@aws-amplify/ui-react";
import { CookieStorage, I18n } from "aws-amplify/utils";
import React, { useContext, useEffect, useState } from "react";
import { signOut } from "aws-amplify/auth";
import { Context } from "../contexts/context";
import BasicLayout from "../components/basicLayout";
import { fetchAuthSession } from "aws-amplify/auth";
import awsconfig from "../aws-exports";

const UserSummary = ({ forceRefreshAuthSession }) => {
	const { user } = useContext(Context);
	const [session, setSession] = useState(null);
	const [links, setLinks] = useState([]);

	const queryParams = new URLSearchParams(window.location.search);

	useEffect(() => {
		async function fetchSession() {
			const session = await fetchAuthSession({
				forceRefresh: forceRefreshAuthSession,
			});
			setSession(session);
		}

		fetchSession();
	}, []);

	useEffect(() => {
		async function checkAuthState() {
			const cookieStorage = new CookieStorage({
				domain: ".cosmogas.com",
				sameSite: "none",
				secure: true,
			});

			const id_token =
				session?.tokens?.idToken.toString() ||
				(await cookieStorage.getItem("id_token"));
			const access_token =
				session?.tokens?.accessToken?.toString() ||
				(await cookieStorage.getItem("access_token"));
			const refresh_token =
				localStorage.getItem(
					`CognitoIdentityServiceProvider.${awsconfig.aws_user_pools_web_client_id}.${session?.tokens?.signInDetails?.loginId}.refreshToken`,
				) || (await cookieStorage.getItem("refresh_token"));

			if (!id_token) {
				return;
			}

			const tokenPayload = JSON.parse(atob(id_token.split(".")[1]));

			setLinks(tokenPayload["cognito:groups"] ?? []);

			const redirect_uri = queryParams.get("redirect_uri");
			const state = queryParams.get("state");

			if (redirect_uri && id_token) {
				try {
					const redirect_uri_url = new URL(redirect_uri);

					redirect_uri_url.searchParams.append("id_token", id_token);
					redirect_uri_url.searchParams.append("access_token", access_token);
					redirect_uri_url.searchParams.append("refresh_token", refresh_token);
					redirect_uri_url.searchParams.append("state", state);

					window.location.replace(redirect_uri_url.toString());
				} catch (error) {
					console.error("Error parsing redirect_uri:", error);
				}
			}
		}

		checkAuthState();
	}, [session]);

	const availablePoints = {
		accesso_documentale: (
			<Link
				href={I18n.get("Account activation success portale link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success portale label")}
			</Link>
		),
		accesso_www: (
			<Link
				href={
					I18n.get("Account activation success website link") +
					"?id_token=" +
					session?.tokens?.idToken
				}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success website label")}
			</Link>
		),
		accesso_cosmoclub: (
			<Link
				href={I18n.get("Account activation success cosmoclub link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success cosmoclub label")}
			</Link>
		),
		accesso_acquacalda: (
			<Link
				href={I18n.get("Account activation success acquacalda link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success acquacalda label")}
			</Link>
		),
		accesso_ricambi: (
			<Link
				href={I18n.get("Account activation success ricambi link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success ricambi label")}
			</Link>
		),
	};

	return (
		<BasicLayout>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "stretch",
				}}
			>
				<Text headingLevel={1} marginBottom={"20px"} textAlign={"center"}>
					{`${I18n.get("Profile hello")} `}
					<b>{user?.email}</b>
					{"!"}
					<br></br>
				</Text>
				{queryParams.get("redirect_uri") && (
					<Text headingLevel={2} marginBottom={"20px"} textAlign={"center"}>
						{I18n.get("Profile redirecting")}
					</Text>
				)}
				<Text
					as="p"
					fontSize="16px"
					fontWeight="500"
					lineHeight="24px"
					textAlign={"center"}
					color="#4A5C7F"
					maxWidth="350px"
					marginInline="auto"
					dangerouslySetInnerHTML={{
						__html:
							links?.length > 0
								? I18n.get("Profile description")
								: I18n.get("Account activation success description"),
					}}
				></Text>
				{links?.length > 0 && (
					<ul
						style={{
							listStyleType: "none",
							padding: 0,
							marginBottom: "32px",
							display: "flex",
							alignItems: "stretch",
							flexDirection: "column",
							gap: "8px",
						}}
					>
						{links?.map((link) => {
							if (!availablePoints[link]) return null;
							return <li key={link}>{availablePoints[link]}</li>;
						})}
					</ul>
				)}
				<Button
					style={{
						width: "fit-content",
						margin: "0 auto",
					}}
					onClick={async () => {
						await signOut();
						window.location.href = "/";
					}}
				>
					Logout
				</Button>
			</div>
		</BasicLayout>
	);
};

export default UserSummary;
